"use strict";
require('whatwg-fetch');
const actionTypes = require('../actionTypes');
const api = require('../api');
const authActions = require('./auth');
exports.startListeningToConnection = (store) => (dispatch) => {
    pollConnection(store, dispatch);
};
const pollConnection = (store, dispatch) => {
    fetch('/images/icons/favicon-16x16.png?' + Date.now())
        .catch(error => {
        console.error('connection poll failed', error);
        handleConnectionChange(false, store, dispatch);
        setTimeout(() => pollConnection(store, dispatch), 1500);
    })
        .then(response => {
        handleConnectionChange(true, store, dispatch);
    });
};
const handleConnectionChange = (isOnline, store, dispatch) => {
    const state = store.getState();
    const wasOnline = state.connection.isOnline;
    if (!wasOnline && isOnline) {
        api.initialize();
        dispatch(authActions.startListeningToAuth());
    }
    dispatch(exports.connectionChanged(isOnline, wasOnline));
};
exports.connectionChanged = (isOnline, wasOnline) => ({
    type: actionTypes.CONNECTION_CHANGED,
    isOnline,
    wasOnline,
});



/** WEBPACK FOOTER **
 ** ./src/actions/connection.ts
 **/